<template>
    <span class="py-1">
        <u-brick-dimension-display :measurements="product.measurements" />
        <div class="text-gray-400 text-sm sm:ml-auto" v-if="hasWeight(product)">
            {{ product.quantity }} x {{ product.measurements.weight }}kg each = {{
                getTotalWeight(product) }}kg
        </div>
    </span>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    methods: {
        hasWeight(product) {
            return product.measurements != null && product.measurements.weight != null;
        },
        getTotalWeight(product) {
            if (!this.hasWeight(product)) {
                return;
            }
            return (product.quantity * product.measurements.weight).toFixed(2);
        },
    },
};
</script>
